<template>
    <div>
        <div class="content-header">
            <div>
                <h2 class="content-title card-title">Message Body</h2>
            </div>
        </div>
        <a-card class="mb-4">
            <h5 class="mb-3">Filter by</h5>
            <form>
                <div class="row">
                    <div class="mb-4 col-md-3">
                        <label for="order_id" class="form-label">Name</label>
                        <input type="text" placeholder="Type here" class="form-control" id="order_id">
                    </div>
                    <div class="mb-4 col-md-3">
                        <label for="order_modified_date" class="form-label">Date</label>
                        <input type="text" placeholder="Type here" class="form-control" id="order_modified_date">
                    </div>
                    <div class="mb-4 col-md-3">
                        <label class="form-label">Status</label>
                        <select class="form-select">
                            <option>Pending</option>
                            <option>Paid</option>
                        </select>
                    </div>
                        
                    <div class="col-md-12 text-right">  
                        <a href="#" class="btn btn-secondary rounded font-md mr-2">Reset</a>
                        <a href="#" class="btn btn-primary rounded font-md ">Filter</a> 
                    </div> 
                </div>
            </form>
        </a-card>
        <a-card >
            <div class="mb-3" style="text-align: right">
                <a-button type="primary" class="btn btn-xs" size="large" @click="showModal"> Create New Message  </a-button>
            </div>
            
            <a-table
                :columns="columns"
                :data-source="data"
                :pagination="{ pageSize: 10 }"
                :scroll="{ y: 300 }"
            > <!-- x: 'calc(600px + 50%)', -->
            
            <span slot="status" slot-scope="text, record">
                {{record.status ? 'Active' : 'Inactive'}}
            </span>

            <span slot="action" > <!-- slot-scope="text, record" -->
                <a-button type="primary" class="mr-3" @click="showModal">
                    Edit
                </a-button>
                <a-button type="danger">
                    Delete
                </a-button>
            </span>
            </a-table>
        </a-card>

        <a-modal
            title="Message"
            :visible="visible"
            :confirm-loading="confirmLoading"
            @ok="handleOk"
            @cancel="handleCancel"
            >
            <a-form layout='vertical' :form="form">
                <a-form-item label='Title'>
                <a-input size="large"
                    v-decorator="[
                    'title',
                    {
                        rules: [{ required: true, message: 'Please input the title of collection!' }],
                    }
                    ]"
                />
                </a-form-item>
                <a-form-item label='Description'>
                <a-input size="large"
                    type='textarea'
                    v-decorator="['description']"
                />
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>


<script>
    const columns = [
        {
            title: 'Status',
            dataIndex: 'name',
        },
        {
            title: 'Message Body',
            dataIndex: 'address',
        },
        {
            title: 'Action',
            key: 'action',
            scopedSlots: { customRender: 'action' },
        }
    ];

    const data = [];
    for (let i = 0; i < 100; i++) {
    data.push({
        key: i,
        name: `Edward King ${i}`,
        age: 32,
        address: `London, Park Lane no. London, Park Lane no. London, Park Lane no. London, Park Lane no. ${i}`,
        status: 1,
        createdAt: "30 May 2020"
    });
    }

export default {
  data() {
    return {
      data,
      columns,
      ModalText: 'Content of the modal',
      visible: false,
      confirmLoading: false,
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handleOk() {
      this.ModalText = 'The modal will be closed after two seconds';
      this.confirmLoading = true;
      setTimeout(() => {
        this.visible = false;
        this.confirmLoading = false;
      }, 2000);
    },
    handleCancel() {
      console.log('Clicked cancel button');
      this.visible = false;
    },
  },
};
</script>